var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',_vm._b({on:{"click":function($event){return _vm.$emit('click', $event)}}},'b-list-group-item',{ ..._vm.$props, variant: _vm.color },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }